import { baseApi } from "../api";

export const hudApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getHudData: builder.query({
			query: () => "/rest/hud/data",
			providesTags: ["hudTag"]
		})
	})
});

export const { useGetHudDataQuery } = hudApi;
